import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class EvaluationDataAuditStore {
    public presetLegendList = new BehaviorSubject<any>(null);

    constructor() {}
}
